(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      var messages = bar.querySelectorAll('.announcement-bar__message');
      if (messages.length < 2) return;

      var current = 0;
      messages.forEach(function (message, index) {
        if (message.classList.contains('is-active')) current = index;
      });

      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 3000;
      var timer = null;

      // Duration must outlast the CSS transition, or the leaving message snaps
      // back to its resting position mid-slide.
      var LEAVE_MS = 500;
      var leaveTimers = [];

      function show(next) {
        var outgoing = messages[current];
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-leaving');
        outgoing.setAttribute('aria-hidden', 'true');

        // Park it back on the entry side once it is out of sight, ready to come
        // round again. Tracked so rapid arrow presses cannot leave one stranded.
        var t = setTimeout(function () {
          outgoing.classList.remove('is-leaving');
        }, LEAVE_MS);
        leaveTimers.push(t);
        if (leaveTimers.length > messages.length) clearTimeout(leaveTimers.shift());

        current = (next + messages.length) % messages.length;
        var incoming = messages[current];
        incoming.classList.remove('is-leaving');
        incoming.classList.add('is-active');
        incoming.removeAttribute('aria-hidden');
      }

      function start() {
        // Someone who has asked for reduced motion gets the first message and no
        // carousel; the arrows still work, so nothing becomes unreachable.
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        stop();
        timer = setInterval(function () {
          show(current + 1);
        }, interval);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // A manual move restarts the clock, so the slide you just chose gets its
      // full dwell time instead of being whisked away mid-read.
      function step(delta) {
        show(current + delta);
        start();
      }

      var prev = bar.querySelector('[data-annc-prev]');
      var next = bar.querySelector('[data-annc-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      start();
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
    }

    function initAll() {
      document.querySelectorAll('.announcement-bar').forEach(initBar);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
  })();

  // Country selector: click to open/close. Click rather than hover so it is
  // reachable on touch. Document-delegated, so it survives the theme editor
  // re-rendering the section.
  (function () {
    function close(wrap) {
      var panel = wrap.querySelector('.cselect__panel');
      var trigger = wrap.querySelector('.cselect__trigger');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      document.querySelectorAll('[data-country-select]').forEach(function (w) {
        if (w !== except) close(w);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('.cselect__trigger');

      if (trigger) {
        var wrap = trigger.closest('[data-country-select]');
        var panel = wrap.querySelector('.cselect__panel');
        var open = panel.hidden;
        closeAll(wrap);
        panel.hidden = !open;
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        event.preventDefault();
        return;
      }

      // Any click outside an open selector closes it. Clicks on a country row
      // are left alone so the link navigates.
      if (!(event.target.closest && event.target.closest('[data-country-select]'))) {
        closeAll(null);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAll(null);
      var open = document.querySelector('.cselect__trigger[aria-expanded="true"]');
      if (open) open.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function syncFooter() {
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      document.querySelectorAll('.footer__col').forEach(function (col) {
        col.open = desktop;
      });
    }

    function initLocale() {
      document.querySelectorAll('.footer__locale-select').forEach(function (select) {
        select.addEventListener('change', function () {
          if (select.form) select.form.submit();
        });
      });
    }

    function init() {
      syncFooter();
      initLocale();
      var mq = window.matchMedia('(min-width: 990px)');
      if (mq.addEventListener) mq.addEventListener('change', syncFooter);
      else if (mq.addListener) mq.addListener(syncFooter);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeader(header) {
      var openers = document.querySelectorAll('[data-drawer-open]');
      var drawer = document.querySelector('[data-drawer]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---------- Desktop dropdown: sync aria + keyboard ---------- */
      var items = header.querySelectorAll('[data-nav-item]');
      Array.prototype.forEach.call(items, function (item) {
        var top = item.querySelector('[data-nav-top]');
        if (!top) return;
        function expand(state) { top.setAttribute('aria-expanded', state ? 'true' : 'false'); }
        item.addEventListener('mouseenter', function () { expand(true); });
        item.addEventListener('mouseleave', function () { expand(false); });
        item.addEventListener('focusin', function () { expand(true); });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) expand(false);
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            expand(false);
            top.focus();
          } else if (e.key === 'ArrowDown') {
            var firstLink = item.querySelector('.nav__panel a');
            if (firstLink) { e.preventDefault(); firstLink.focus(); }
          }
        });
      });

      /* Arrow Left/Right move between top-level items. */
      var tops = header.querySelectorAll('[data-nav-top]');
      header.addEventListener('keydown', function (e) {
        /* Roving focus follows READING order, not physical direction: in RTL the
           nav runs right-to-left, so ArrowRight moves to the previous item.
           See assets/diesel-rtl-scroll.js. */
        var keyDir = window.DieselScroll.arrowDir(e.key, header);
        if (!keyDir) return;
        var list = Array.prototype.slice.call(tops);
        var idx = list.indexOf(document.activeElement);
        if (idx === -1) return;
        e.preventDefault();
        var next = idx + keyDir;
        if (next < 0) next = list.length - 1;
        if (next >= list.length) next = 0;
        list[next].focus();
      });

      /* ---------- Search toggle ---------- */
      var searchToggle = header.querySelector('[data-search-toggle]');
      var searchPanel = header.querySelector('[data-search-panel]');
      if (searchToggle && searchPanel) {
        var searchInput = searchPanel.querySelector('[data-search-input]');
        var searchResults = searchPanel.querySelector('[data-search-results]');
        var searchDefault = searchPanel.querySelector('[data-search-default]');
        var searchClose = searchPanel.querySelector('[data-search-close]');
        var searchScrim = null;
        var searchDebounce = null;
        var searchAbort = null;
        var searchRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var siteHeader = searchPanel.closest('.site-header') || header;

        /* Scrim starts at the panel's bottom (content-driven) and covers the page
           below it, so it grows/shrinks with the panel content. */
        function updateScrim() {
          if (!searchScrim) return;
          searchScrim.style.top = Math.round(searchPanel.getBoundingClientRect().bottom) + 'px';
        }
        function scheduleScrim() {
          if (window.requestAnimationFrame) requestAnimationFrame(updateScrim);
          else updateScrim();
        }
        function showScrim() {
          if (searchScrim) return;
          searchScrim = document.createElement('div');
          searchScrim.className = 'sd-scrim';
          searchScrim.addEventListener('click', function () { closeSearch(); });
          document.body.appendChild(searchScrim);
        }
        function hideScrim() {
          if (searchScrim) { searchScrim.remove(); searchScrim = null; }
        }
        function showDefault() {
          if (searchResults) { searchResults.hidden = true; searchResults.innerHTML = ''; }
          if (searchDefault) searchDefault.hidden = false;
          scheduleScrim();
        }
        function fetchPredictive(term) {
          if (searchAbort) searchAbort.abort();
          searchAbort = new AbortController();
          var url = searchRoot + 'search/suggest?q=' + encodeURIComponent(term) +
            '&section_id=predictive-search&resources[type]=query,product&resources[limit]=4';
          fetch(url, { signal: searchAbort.signal })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var tmp = document.createElement('div');
              tmp.innerHTML = html.trim();
              var sec = tmp.querySelector('#shopify-section-predictive-search');
              if (searchDefault) searchDefault.hidden = true;
              searchResults.innerHTML = sec ? sec.innerHTML : tmp.innerHTML;
              searchResults.hidden = false;
              scheduleScrim();
            })
            .catch(function (e) { if (e.name !== 'AbortError') showDefault(); });
        }
        function onSearchInput() {
          var term = (searchInput.value || '').trim();
          if (searchDebounce) clearTimeout(searchDebounce);
          if (term.length < 2) { if (searchAbort) searchAbort.abort(); showDefault(); return; }
          searchDebounce = setTimeout(function () { fetchPredictive(term); }, 200);
        }

        var onSearchKey = function (e) {
          if (e.key === 'Escape') {
            closeSearch();
            searchToggle.focus();
          }
        };
        var onDocClick = function (e) {
          if (!searchPanel.contains(e.target) && !searchToggle.contains(e.target)) closeSearch();
        };
        var onSearchResize = function () { updateScrim(); };

        function openSearch() {
          searchPanel.hidden = false;
          searchToggle.setAttribute('aria-expanded', 'true');
          if (siteHeader) siteHeader.classList.add('search-open');  /* replace nav row */
          document.documentElement.style.overflow = 'hidden';        /* lock body scroll */
          showScrim();
          showDefault();
          if (searchInput) searchInput.focus();
          document.addEventListener('keydown', onSearchKey);
          document.addEventListener('click', onDocClick);
          window.addEventListener('resize', onSearchResize);
          scheduleScrim();
        }
        function closeSearch() {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
          if (siteHeader) siteHeader.classList.remove('search-open');
          document.documentElement.style.overflow = '';
          hideScrim();
          document.removeEventListener('keydown', onSearchKey);
          document.removeEventListener('click', onDocClick);
          window.removeEventListener('resize', onSearchResize);
        }

        if (searchInput) searchInput.addEventListener('input', onSearchInput);
        if (searchClose) searchClose.addEventListener('click', function () { closeSearch(); searchToggle.focus(); });

        searchToggle.addEventListener('click', function (e) {
          e.stopPropagation();
          if (searchPanel.hidden) openSearch();
          else closeSearch();
        });
      }

      /* ---------- Mobile drawer ---------- */
      if (!drawer) return;
      /* Portal the drawer to <body>: the header section group carries
         `will-change: transform`, which makes it the containing block for
         position:fixed — trapping the full-screen overlay inside the 39px
         header. Re-parenting to <body> lets `fixed` resolve to the viewport. */
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      var panel = drawer.querySelector('[data-drawer-panel]');
      var closers = drawer.querySelectorAll('[data-drawer-close]');
      var lastFocused = null;

      function focusable() {
        /* Only the persistent head + the currently-active view are reachable —
           off-screen (drilled) views must stay out of the tab order. */
        var scope = [];
        var head = panel.querySelector('.mmenu__head');
        var active = panel.querySelector('.mmenu__view.is-active') || panel;
        if (head) scope.push(head);
        scope.push(active);
        var out = [];
        scope.forEach(function (region) {
          out = out.concat(
            Array.prototype.slice.call(region.querySelectorAll('a[href], button:not([disabled])'))
          );
        });
        return out.filter(function (el) { return el.offsetParent !== null; });
      }

      function openDrawer() {
        lastFocused = document.activeElement;
        /* always open on the top-level list, accordions collapsed */
        resetViews();
        drawer.hidden = false;
        /* allow layout before transition */
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'true'); });
        var f = focusable();
        if (f.length) f[0].focus();
        document.addEventListener('keydown', onKeydown);
      }

      function closeDrawer() {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        Array.prototype.forEach.call(openers, function (o) { o.setAttribute('aria-expanded', 'false'); });
        document.removeEventListener('keydown', onKeydown);
        var finish = function () { drawer.hidden = true; };
        if (reduce) finish();
        else setTimeout(finish, 280);
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      function onKeydown(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeDrawer();
        } else if (e.key === 'Tab') {
          var f = focusable();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        }
      }

      Array.prototype.forEach.call(openers, function (o) {
        o.addEventListener('click', openDrawer);
      });
      Array.prototype.forEach.call(closers, function (c) {
        c.addEventListener('click', closeDrawer);
      });

      /* ---------- Multi-level push navigation ----------
         Level 1 → 2 = PUSH (slide a sub-panel in, Back returns to previous view).
         Level 2 → 3 = ACCORDION (expand in place). See mobile-menu-spec.md. */
      var viewport = drawer.querySelector('[data-mm-viewport]');
      var views = viewport
        ? Array.prototype.slice.call(viewport.querySelectorAll('[data-mm-view]'))
        : [];
      var viewById = {};
      views.forEach(function (v) { viewById[v.getAttribute('data-mm-view')] = v; });
      /* Stack of view ids, deepest last. Root is always the base. */
      var stack = ['root'];

      /* Pin the clip container to its inline-start edge, so the off-screen
         panels never leave the header horizontally scrollable.

         `viewport.scrollLeft = 0` is only the neutral position in LTR. In RTL it
         depends on the engine's scrollLeft convention — under the legacy WebKit
         ('default') convention the start is maxScroll, so assigning 0 scrolls to
         the END and reveals the parked panel instead of hiding it. DieselScroll
         normalises all three conventions (see assets/diesel-rtl-scroll.js). */
      function pinViewport() {
        if (!viewport) return;
        if (window.DieselScroll) window.DieselScroll.scrollToStart(viewport, 'auto');
        else viewport.scrollLeft = 0;
      }

      function renderStack() {
        var topId = stack[stack.length - 1];
        views.forEach(function (v) {
          var id = v.getAttribute('data-mm-view');
          v.classList.remove('is-active', 'is-past');
          if (id === topId) {
            v.classList.add('is-active');
            v.removeAttribute('aria-hidden');
          } else {
            if (stack.indexOf(id) > -1) v.classList.add('is-past');
            v.setAttribute('aria-hidden', 'true');
          }
        });
        /* Off-screen (translateX ±100%) panels add horizontal scroll overflow to
           the clip container; keep it pinned so nothing drifts sideways. */
        pinViewport();
      }

      /* focus() would scroll the off-screen panel into view (shifting the whole
         viewport); preventScroll avoids that. Fall back for old engines. */
      function focusNoScroll(el) {
        if (!el) return;
        try { el.focus({ preventScroll: true }); }
        catch (err) { el.focus(); }
        pinViewport();
      }

      function pushView(id) {
        if (!viewById[id]) return;
        stack.push(id);
        renderStack();
        focusNoScroll(viewById[id].querySelector('a[href], button:not([disabled])'));
      }

      function backView() {
        if (stack.length <= 1) return;
        var leaving = stack.pop();
        renderStack();
        /* return focus to the row that opened the panel we just left */
        focusNoScroll(viewport.querySelector('[data-mm-push="' + leaving + '"]'));
      }

      function resetViews() {
        if (!viewport) return;
        stack = ['root'];
        Array.prototype.forEach.call(
          viewport.querySelectorAll('[data-mm-acc][aria-expanded="true"]'),
          function (t) {
            t.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          }
        );
        // Re-open the per-category default accordions (e.g. Men → Ready to wear),
        // so each fresh drawer open starts them expanded.
        Array.prototype.forEach.call(
          viewport.querySelectorAll('[data-mm-acc-default]'),
          function (t) {
            t.setAttribute('aria-expanded', 'true');
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = false;
          }
        );
        renderStack();
      }

      if (viewport) {
        viewport.addEventListener('click', function (e) {
          var push = e.target.closest('[data-mm-push]');
          if (push) { pushView(push.getAttribute('data-mm-push')); return; }
          var back = e.target.closest('[data-mm-back]');
          if (back) { backView(); return; }
          var acc = e.target.closest('[data-mm-acc]');
          if (acc) {
            var expanded = acc.getAttribute('aria-expanded') === 'true';
            acc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            var accPanel = document.getElementById(acc.getAttribute('aria-controls'));
            if (accPanel) accPanel.hidden = expanded;
          }
        });
      }

      /* Escape steps back a level when drilled in; closes the drawer at root.
         Augments the base onKeydown (which handles the focus trap + close). */
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && stack.length > 1) {
          e.stopPropagation();
          backView();
        }
      }, true);
    }

    function initAll() {
      document.querySelectorAll('[data-site-header]').forEach(initHeader);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlights-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var track = root.querySelector('.hl-grid__track');
      if (!track) return;

      var realTiles = Array.prototype.slice.call(track.querySelectorAll('.hl-grid__tile'));
      var n = realTiles.length;
      var nav = root.querySelector('.hl-grid__nav');
      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (n < 2) {
        if (nav) nav.style.display = 'none';
        return;
      }

      // Clone the edge tiles so the slider loops seamlessly.
      var CLONES = Math.min(2, n);
      function makeClone(sourceIndex) {
        var clone = realTiles[sourceIndex].cloneNode(true);
        clone.classList.add('hl-grid__tile--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('id');
        return clone;
      }
      var i;
      for (i = 0; i < CLONES; i++) {
        track.insertBefore(makeClone(n - 1 - i), track.firstChild); // -> [n-2, n-1, ...reals]
      }
      for (i = 0; i < CLONES; i++) {
        track.appendChild(makeClone(i)); // -> [...reals, 0, 1]
      }

      // DOM index is the single source of truth; reals occupy [realStart, realEnd].
      var realStart = CLONES;
      var realEnd = CLONES + n - 1;
      var index = realStart;

      function tiles() {
        return track.querySelectorAll('.hl-grid__tile');
      }

      // Centre a tile. Was offsetLeft (always physical/LTR-origin) fed into
      // scrollTo({left}) (negative in RTL) — two different coordinate systems.
      // The helper measures live rects instead, so it is correct both ways.
      // See assets/diesel-rtl-scroll.js.
      function scrollToIndex(i, behavior) {
        var tile = tiles()[i];
        if (tile) {
          window.DieselScroll.scrollToElement(track, tile, {
            align: 'center',
            behavior: behavior,
            instant: behavior === 'auto'
          });
        }
      }

      function nearestIndex() {
        var i = window.DieselScroll.nearestIndex(track, '.hl-grid__tile', 'center');
        return i < 0 ? realStart : i;
      }

      // Pull any clone position back to its matching real tile (instant, seamless).
      function wrap() {
        if (index < realStart) { index += n; scrollToIndex(index, 'auto'); }
        else if (index > realEnd) { index -= n; scrollToIndex(index, 'auto'); }
      }

      function move(dir) {
        wrap(); // collapse any pending clone position from a previous rapid click
        index += dir;
        scrollToIndex(index, reduce ? 'auto' : 'smooth');
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      track.addEventListener('keydown', function (e) {
        // Arrow keys are physical, movement is logical: ArrowRight is "previous"
        // in RTL. arrowDir returns +1 next / -1 prev / 0 for other keys.
        var d = window.DieselScroll.arrowDir(e.key, track);
        if (d) { e.preventDefault(); move(d); }
      });

      // When scrolling settles (touch swipe, momentum or after an arrow), sync
      // the index from the resting position and loop if we landed on a clone.
      var settleTimer = null;
      track.addEventListener('scroll', function () {
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          index = nearestIndex();
          wrap();
        }, 120);
      }, { passive: true });

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { scrollToIndex(index, 'auto'); }, 150);
      });

      // Start centred on the first real tile (last tile peeks on the left).
      requestAnimationFrame(function () { scrollToIndex(realStart, 'auto'); });
    }

    function initAll() {
      document.querySelectorAll('.hl-grid').forEach(initCarousel);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    var modal = document.getElementById('DieselRemoveModal');
    if (!modal) return;
    var nameEl = modal.querySelector('[data-remove-name]');
    var confirmBtn = modal.querySelector('[data-remove-confirm]');
    var pendingHref = null;

    function openModal(href, name) {
      pendingHref = href;
      nameEl.textContent = name || '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.hidden = true;
      pendingHref = null;
      document.body.style.overflow = '';
    }

    // Intercept the remove click in the capture phase, before Dawn's
    // cart-remove-button handler, and show the confirmation first.
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('cart-remove-button a');
        if (!link) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var item = link.closest('.cart-item');
        var nameNode = item ? item.querySelector('.cart-item__name') : null;
        openModal(link.getAttribute('href'), nameNode ? nameNode.textContent.trim() : '');
      },
      true
    );

    modal.querySelectorAll('[data-remove-cancel]').forEach(function (b) {
      b.addEventListener('click', closeModal);
    });
    confirmBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (pendingHref) window.location.href = pendingHref;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Card hover gallery (deferred image load + prev/next arrows) lives in the
  // shared asset diesel-card-gallery.js, loaded near the top of this section and
  // on search so both grids behave identically.

  // Filter drawer (uk.diesel.com style): inject a boxed red × close in the panel
  // header, close on scrim-click / Escape, and use uk's button labels. Re-applied
  // after Dawn re-renders the facets markup on each filter change.
  (function () {
    function enhance() {
      var disclosure = document.querySelector('.diesel-filter-aside .mobile-facets__disclosure');
      if (!disclosure) return;
      // Fallback for browsers without :has() — toggle a class that lifts the
      // filter bar above the sticky header while the drawer is open.
      if (!disclosure.dataset.dieselZ) {
        disclosure.dataset.dieselZ = '1';
        disclosure.addEventListener('toggle', function () {
          var bar = disclosure.closest('.diesel-filter-bar');
          if (bar) bar.classList.toggle('is-drawer-open', disclosure.open);
        });
      }
      var header = disclosure.querySelector('.mobile-facets__header');
      if (header && !header.querySelector('.diesel-facets__close')) {
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'diesel-facets__close';
        x.setAttribute('aria-label', 'Close');
        x.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
        x.addEventListener('click', function () { disclosure.open = false; });
        header.appendChild(x);
      }
      var footer = disclosure.querySelector('.mobile-facets__main > .mobile-facets__footer');
      if (footer) {
        var clear = footer.querySelector('.mobile-facets__clear');
        if (clear && clear.textContent.trim() !== 'Clear all') clear.textContent = 'Clear all';
        var apply = footer.querySelector('.button');
        if (apply && apply.textContent.trim() !== 'Apply filter') apply.textContent = 'Apply filter';
      }
    }
    enhance();
    // Close when the dimmed scrim (not the panel) is clicked.
    document.addEventListener('click', function (e) {
      var scrim = e.target.closest && e.target.closest('.mobile-facets');
      if (scrim && !e.target.closest('.mobile-facets__inner')) {
        var d = scrim.closest('.mobile-facets__disclosure') || document.querySelector('.mobile-facets__disclosure[open]');
        if (d) d.open = false;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var d = document.querySelector('.mobile-facets__disclosure[open]'); if (d) d.open = false; }
    });
    var host = document.querySelector('.diesel-filter-aside');
    if (host && window.MutationObserver) {
      new MutationObserver(enhance).observe(host, { childList: true, subtree: true });
    }
  })();

  // Keep the filter-bar's applied-filter chips + result count in sync with Dawn's
  // AJAX filtering. facets.js renderPage only refreshes #ProductGridContainer, the
  // drawer facets and #ProductCount — NOT our #DieselActiveFilters chips or the
  // .diesel-filter-count in the bar — so without this they'd only update on a full
  // reload. renderProductGridContainer receives the fresh section HTML; wrap it to
  // swap those two bits in too.
  (function () {
    function patch() {
      if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderProductGridContainer) return false;
      if (FacetFiltersForm.__dieselBarSync) return true;
      FacetFiltersForm.__dieselBarSync = true;
      var orig = FacetFiltersForm.renderProductGridContainer;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        orig(html);
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['#DieselActiveFilters', '.diesel-filter-count'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var cur = document.querySelector(sel);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
        } catch (e) {}
      };
      return true;
    }
    if (!patch()) {
      var tries = 0;
      var t = setInterval(function () {
        if (patch() || ++tries > 40) clearInterval(t);
      }, 50);
    }
  })();

  // Snap product-grid columns to whole pixels so every red gridline renders at
  // an identical width (fractional 1fr columns make some cell borders land on 2
  // device px and others on ~1, so some lines look thicker). Cells are
  // border-box with 1px right/bottom borders and gap:0, so the columns simply
  // fill the grid's content box (grid width minus its 1px left + right borders).
  (function () {
    var grid = document.querySelector('.diesel-product-grid');
    if (!grid) return;
    function snapColumns() {
      var styles = getComputedStyle(grid);
      var cols = parseInt(styles.getPropertyValue('--diesel-cols'), 10) || 4;
      if (window.matchMedia('(max-width: 749px)').matches) {
        cols = parseInt(styles.getPropertyValue('--diesel-cols-mobile'), 10) || 2;
      }
      grid.style.gridTemplateColumns = '';
      var width = Math.round(grid.getBoundingClientRect().width);
      // subtract the 1px left + right outer borders; no gaps (borders live inside
      // each border-box cell)
      var available = width - 2;
      var base = Math.floor(available / cols);
      var remainder = available - base * cols;
      var parts = [];
      for (var i = 0; i < cols; i++) {
        parts.push((base + (i < remainder ? 1 : 0)) + 'px');
      }
      grid.style.gridTemplateColumns = parts.join(' ');
    }
    snapColumns();
    window.addEventListener('resize', snapColumns);
  })();

  // Directional sticky header + logo shrink on the collection page.
  // Directional sticky header + logo compress now lives in
  // assets/diesel-sticky-header.js, loaded via a <script defer> above, and is
  // shared with the other templates that use it. It was three identical inline
  // copies, which is how one off-by-40px bug reached all three at once.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["man-denim-guide"] && !Shopify.designMode) return;
  try {
    
  // Active-fit highlight — desktop pills AND the mobile "Choose your fit" list.
  (function () {
    document.querySelectorAll('.mdg').forEach(function (root) {
      var sections = root.querySelectorAll('[data-mdg-section]');
      var navItems = root.querySelectorAll('[data-mdg-pill], [data-mdg-cyf-item]');
      if (!sections.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          navItems.forEach(function (p) { p.classList.remove('is-active'); });
          root.querySelectorAll('[data-mdg-pill="' + e.target.id + '"], [data-mdg-cyf-item="' + e.target.id + '"]')
            .forEach(function (p) { p.classList.add('is-active'); });
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      sections.forEach(function (s) { io.observe(s); });
    });
  })();

  // Mobile "Choose your fit" dropdown — expand/collapse; close after a fit is picked.
  (function () {
    document.querySelectorAll('[data-mdg-cyf]').forEach(function (cyf) {
      var toggle = cyf.querySelector('[data-mdg-cyf-toggle]');
      var list = cyf.querySelector('[data-mdg-cyf-list]');
      if (!toggle || !list) return;
      function setOpen(open) {
        if (open) { cyf.setAttribute('data-open', ''); list.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
        else { cyf.removeAttribute('data-open'); list.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      }
      toggle.addEventListener('click', function () { setOpen(!cyf.hasAttribute('data-open')); });
      list.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    });
  })();

  // Directional sticky header + logo compress — same behaviour as the PLP
  // (main-collection-product-grid.liquid): toggles body.diesel-top / diesel-up /
  // diesel-down so the header slides away on scroll-down and returns on scroll-up
  // with the logo shrunk. The CSS for these classes ships in this section.
  // Directional sticky header + logo compress now lives in
  // assets/diesel-sticky-header.js, loaded via a <script defer> above, and is
  // shared with the other templates that use it. It was three identical inline
  // copies, which is how one off-by-40px bug reached all three at once.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-wanted-denim"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var track = root.querySelector('.denim__track');
      if (!track) return;

      var realCards = Array.prototype.slice.call(track.querySelectorAll('.denim-card'));
      var n = realCards.length;
      var nav = root.querySelector('.denim__nav');
      var prev = root.querySelector('[data-dir="prev"]');
      var next = root.querySelector('[data-dir="next"]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (n < 2) {
        if (nav) nav.style.display = 'none';
        return;
      }

      // Clone the full set on both sides so the row loops seamlessly at any card count per view.
      function makeClone(card) {
        var clone = card.cloneNode(true);
        clone.classList.add('denim-card--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('id');
        return clone;
      }
      var lead = document.createDocumentFragment();
      var trail = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        lead.appendChild(makeClone(realCards[i]));
        trail.appendChild(makeClone(realCards[i]));
      }
      track.insertBefore(lead, track.firstChild); // [setA][reals]
      track.appendChild(trail); // [setA][reals][setC]

      var realStart = n;
      var realEnd = 2 * n - 1;
      var index = realStart;

      function cards() {
        return track.querySelectorAll('.denim-card');
      }

      // Flush a card to the inline-start edge — its LEFT in LTR, its RIGHT in
      // RTL. Was offsetLeft (always physical/LTR-origin) fed into
      // scrollTo({left}) (negative in RTL), mixing coordinate systems. The
      // helper measures live rects. See assets/diesel-rtl-scroll.js.
      function scrollToIndex(i, behavior) {
        var card = cards()[i];
        if (card) {
          window.DieselScroll.scrollToElement(track, card, {
            align: 'start',
            behavior: behavior,
            instant: behavior === 'auto'
          });
        }
      }

      function nearestIndex() {
        var i = window.DieselScroll.nearestIndex(track, '.denim-card', 'start');
        return i < 0 ? realStart : i;
      }

      function wrap() {
        if (index < realStart) { index += n; scrollToIndex(index, 'auto'); }
        else if (index > realEnd) { index -= n; scrollToIndex(index, 'auto'); }
      }

      function move(dir) {
        wrap();
        index += dir;
        scrollToIndex(index, reduce ? 'auto' : 'smooth');
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      track.addEventListener('keydown', function (e) {
        // ArrowRight means "previous" in RTL — see assets/diesel-rtl-scroll.js.
        var d = window.DieselScroll.arrowDir(e.key, track);
        if (d) { e.preventDefault(); move(d); }
      });

      var settleTimer = null;
      track.addEventListener('scroll', function () {
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          index = nearestIndex();
          wrap();
        }, 120);
      }, { passive: true });

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { scrollToIndex(index, 'auto'); }, 150);
      });

      requestAnimationFrame(function () { scrollToIndex(realStart, 'auto'); });
    }

    function initAll() {
      document.querySelectorAll('.denim').forEach(initCarousel);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-mrecs-prev], [data-mrecs-next]');
    if (nav) {
      var carousel = nav.closest('[data-mrecs-carousel]');
      var track = carousel && carousel.querySelector('[data-mrecs-track]');
      if (!track) return;
      var cell = track.querySelector('.mrecs-cell');
      var step = cell ? cell.getBoundingClientRect().width : track.clientWidth / 2;
      var pages = Math.max(1, Math.round(track.clientWidth / step) - 1);
      var dir = nav.hasAttribute('data-mrecs-next') ? 1 : -1;
      // Logical paging — "next" moves the viewport LEFT in RTL.
      // See assets/diesel-rtl-scroll.js.
      window.DieselScroll.page(track, dir, step * pages, 'smooth');
      return;
    }
    var heart = e.target.closest('.mrecs-wishlist');
    if (heart) {
      var pressed = heart.getAttribute('aria-pressed') === 'true';
      heart.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    }
  });
  // Tab switcher: swap the visible group and rewind the track. Delegated so it
  // survives a section re-render in the theme editor.
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-mrecs-tab]');
    if (!tab) return;
    var block = tab.closest('[data-mrecs-carousel]');
    if (!block) return;
    e.preventDefault();
    var key = tab.getAttribute('data-mrecs-tab');
    if (block.getAttribute('data-mrecs-active') === key) return;
    block.setAttribute('data-mrecs-active', key);
    var tabs = block.querySelectorAll('[data-mrecs-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-mrecs-tab') === key;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    var track = block.querySelector('[data-mrecs-track]');
    if (track) track.scrollLeft = 0;
  });

  // In-card gallery: the arrows only move --gindex; CSS does the sliding.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mrecs-gprev], [data-mrecs-gnext]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('[data-mrecs-gallery]');
    if (!wrap) return;
    var track = wrap.querySelector('.mrecs-gal__track');
    if (!track) return;
    // Swap in the deferred images the first time this card is navigated.
    var lazy = wrap.querySelectorAll('img[data-mrecs-lazysrc]');
    for (var j = 0; j < lazy.length; j++) {
      var srcset = lazy[j].getAttribute('data-mrecs-lazysrcset');
      if (srcset) lazy[j].setAttribute('srcset', srcset);
      lazy[j].setAttribute('src', lazy[j].getAttribute('data-mrecs-lazysrc'));
      lazy[j].removeAttribute('data-mrecs-lazysrc');
      lazy[j].removeAttribute('data-mrecs-lazysrcset');
    }
    var count = track.querySelectorAll('.mrecs-gal__img').length;
    if (count < 2) return;
    var cur = parseInt(track.style.getPropertyValue('--gindex'), 10) || 0;
    var dir = btn.hasAttribute('data-mrecs-gnext') ? 1 : -1;
    track.style.setProperty('--gindex', (cur + dir + count) % count);
  });

  // Mobile: keep the active swipe dot in sync with the scroll-snap carousel
  // (same as the PLP card). Scroll events don't bubble, so listen in capture.
  document.addEventListener('scroll', function (e) {
    var track = e.target && e.target.closest && e.target.closest('.mrecs-gal__track');
    if (!track) return;
    var wrap = track.closest('[data-mrecs-gallery]');
    if (!wrap) return;
    var dots = wrap.querySelectorAll('.mrecs-gal__dot');
    if (!dots.length) return;
    var idx = window.DieselScroll.indexFromOffset(track, track.clientWidth, dots.length);
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }, { capture: true, passive: true });

  // Mobile has no hover: load the deferred (2nd+) images the first time the user
  // touches a card gallery so the swipe carousel has them ready.
  document.addEventListener('touchstart', function (e) {
    var wrap = e.target && e.target.closest && e.target.closest('[data-mrecs-gallery]');
    if (!wrap) return;
    var lazy = wrap.querySelectorAll('img[data-mrecs-lazysrc]');
    for (var j = 0; j < lazy.length; j++) {
      var ss = lazy[j].getAttribute('data-mrecs-lazysrcset');
      if (ss) lazy[j].setAttribute('srcset', ss);
      lazy[j].setAttribute('src', lazy[j].getAttribute('data-mrecs-lazysrc'));
      lazy[j].removeAttribute('data-mrecs-lazysrc');
      lazy[j].removeAttribute('data-mrecs-lazysrcset');
    }
  }, { passive: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  /* Carousel arrows + wishlist toggle. Delegated on document so they work after
     <product-recommendations> swaps in its fetched markup. */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-recs-prev], [data-recs-next]');
    if (nav) {
      var carousel = nav.closest('[data-recs-carousel]');
      var track = carousel && carousel.querySelector('[data-recs-track]');
      if (!track) return;
      var cell = track.querySelector('.diesel-recs-cell');
      var step = cell ? cell.getBoundingClientRect().width : track.clientWidth / 2;
      var pages = Math.max(1, Math.round(track.clientWidth / step) - 1);
      var dir = nav.hasAttribute('data-recs-next') ? 1 : -1;
      // Logical paging: "next" moves the viewport LEFT in RTL, so the physical
      // sign flips. See assets/diesel-rtl-scroll.js.
      window.DieselScroll.page(track, dir, step * pages, 'smooth');
      return;
    }
    var heart = e.target.closest('.diesel-recs-wishlist');
    if (heart) {
      var pressed = heart.getAttribute('aria-pressed') === 'true';
      heart.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    }
  });

  /* Auto-scroll: advance one card every few seconds and loop back at the end,
     like uk.diesel.com (no progress bar). Pauses while the carousel is hovered
     or the tab is hidden, and is disabled for prefers-reduced-motion users.
     Uses :hover checks + [data-recs-track] lookup so it works after
     <product-recommendations> swaps in its fetched markup. */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var INTERVAL = 4000;
    setInterval(function () {
      if (document.hidden) return;
      document.querySelectorAll('[data-recs-carousel]').forEach(function (carousel) {
        if (carousel.matches(':hover')) return;
        var track = carousel.querySelector('[data-recs-track]');
        if (!track || track.scrollWidth <= track.clientWidth + 2) return;
        /* `scrollLeft + clientWidth >= scrollWidth` is guaranteed FALSE in RTL,
           where scrollLeft is <= 0 — so the loop never wrapped and the carousel
           dead-ended at the last card. DieselScroll.atEnd normalises the offset
           to a distance-from-inline-start. See assets/diesel-rtl-scroll.js. */
        if (window.DieselScroll.atEnd(track)) {
          window.DieselScroll.scrollToStart(track, 'smooth');
        } else {
          var cell = track.querySelector('.diesel-recs-cell');
          var step = cell ? cell.getBoundingClientRect().width : track.clientWidth;
          window.DieselScroll.page(track, 1, step, 'smooth');
        }
      });
    }, INTERVAL);
  })();
  // In-card gallery: arrows only move --gindex; CSS slides the track.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dsc-gprev], [data-dsc-gnext]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('[data-dsc-gallery]');
    if (!wrap) return;
    var track = wrap.querySelector('.dsc-gal__track');
    if (!track) return;
    var lazy = wrap.querySelectorAll('img[data-dsc-lazysrc]');
    for (var j = 0; j < lazy.length; j++) {
      var ss = lazy[j].getAttribute('data-dsc-lazysrcset');
      if (ss) lazy[j].setAttribute('srcset', ss);
      lazy[j].setAttribute('src', lazy[j].getAttribute('data-dsc-lazysrc'));
      lazy[j].removeAttribute('data-dsc-lazysrc');
      lazy[j].removeAttribute('data-dsc-lazysrcset');
    }
    var count = track.querySelectorAll('.dsc-gal__img').length;
    if (count < 2) return;
    var cur = parseInt(track.style.getPropertyValue('--gindex'), 10) || 0;
    var dir = btn.hasAttribute('data-dsc-gnext') ? 1 : -1;
    track.style.setProperty('--gindex', (cur + dir + count) % count);
  });

  // Mobile: keep the active swipe dot in sync with the scroll-snap carousel
  // (same as the PLP card). Scroll events don't bubble, so listen in capture.
  document.addEventListener('scroll', function (e) {
    var track = e.target && e.target.closest && e.target.closest('.dsc-gal__track');
    if (!track) return;
    var wrap = track.closest('[data-dsc-gallery]');
    if (!wrap) return;
    var dots = wrap.querySelectorAll('.dsc-gal__dot');
    if (!dots.length) return;
    var idx = window.DieselScroll.indexFromOffset(track, track.clientWidth, dots.length);
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === idx);
  }, { capture: true, passive: true });

  // Mobile has no hover and no arrows: load the deferred (2nd+) images the first
  // time the user touches a card gallery so the swipe carousel has them ready.
  document.addEventListener('touchstart', function (e) {
    var wrap = e.target && e.target.closest && e.target.closest('[data-dsc-gallery]');
    if (!wrap) return;
    var lazy = wrap.querySelectorAll('img[data-dsc-lazysrc]');
    for (var j = 0; j < lazy.length; j++) {
      var ss = lazy[j].getAttribute('data-dsc-lazysrcset');
      if (ss) lazy[j].setAttribute('srcset', ss);
      lazy[j].setAttribute('src', lazy[j].getAttribute('data-dsc-lazysrc'));
      lazy[j].removeAttribute('data-dsc-lazysrc');
      lazy[j].removeAttribute('data-dsc-lazysrcset');
    }
  }, { passive: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Keep the search filter-bar's applied-filter chips + result count in sync with
  // Dawn's AJAX filtering. facets.js renderPage only refreshes #ProductGridContainer,
  // the drawer facets and #ProductCount — not our #DieselActiveFilters chips or the
  // .diesel-filter-count — so without this they'd only update on a full reload. This
  // mirrors the patch in sections/main-collection-product-grid.liquid (whose section
  // JS isn't loaded on the search page, since section scripts load per-page).
  (function () {
    function patch() {
      if (typeof FacetFiltersForm === 'undefined' || !FacetFiltersForm.renderProductGridContainer) return false;
      if (FacetFiltersForm.__dieselBarSync) return true;
      FacetFiltersForm.__dieselBarSync = true;
      var orig = FacetFiltersForm.renderProductGridContainer;
      FacetFiltersForm.renderProductGridContainer = function (html) {
        orig(html);
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['#DieselActiveFilters', '.diesel-filter-count'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var cur = document.querySelector(sel);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
        } catch (e) {}
      };
      return true;
    }
    if (!patch()) {
      var tries = 0;
      var t = setInterval(function () {
        if (patch() || ++tries > 40) clearInterval(t);
      }, 50);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["women-denim-guide"] && !Shopify.designMode) return;
  try {
    
  // Active-fit highlight — desktop pills AND the mobile "Choose your fit" list.
  (function () {
    document.querySelectorAll('.mdg').forEach(function (root) {
      var sections = root.querySelectorAll('[data-mdg-section]');
      var navItems = root.querySelectorAll('[data-mdg-pill], [data-mdg-cyf-item]');
      if (!sections.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          navItems.forEach(function (p) { p.classList.remove('is-active'); });
          root.querySelectorAll('[data-mdg-pill="' + e.target.id + '"], [data-mdg-cyf-item="' + e.target.id + '"]')
            .forEach(function (p) { p.classList.add('is-active'); });
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      sections.forEach(function (s) { io.observe(s); });
    });
  })();

  // Mobile "Choose your fit" dropdown — expand/collapse; close after a fit is picked.
  (function () {
    document.querySelectorAll('[data-mdg-cyf]').forEach(function (cyf) {
      var toggle = cyf.querySelector('[data-mdg-cyf-toggle]');
      var list = cyf.querySelector('[data-mdg-cyf-list]');
      if (!toggle || !list) return;
      function setOpen(open) {
        if (open) { cyf.setAttribute('data-open', ''); list.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
        else { cyf.removeAttribute('data-open'); list.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      }
      toggle.addEventListener('click', function () { setOpen(!cyf.hasAttribute('data-open')); });
      list.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    });
  })();

  // Directional sticky header + logo compress — same behaviour as the PLP.
  // Directional sticky header + logo compress now lives in
  // assets/diesel-sticky-header.js, loaded via a <script defer> above, and is
  // shared with the other templates that use it. It was three identical inline
  // copies, which is how one off-by-40px bug reached all three at once.

  } catch(e) { console.error(e); }
})();
})();
